import $ from 'jquery';
import debounce from 'just-debounce';
import $script from 'scriptjs';
import MobileNav from '../snippets/NavMobile';
import DesktopNav from '../snippets/NavDesktop';
import Meganav from '../snippets/Meganav';
import Layout from '../Layout';

export default class HeaderStaticSection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.$mobileNavToggle = this.$el.find('[data-mobilenav-toggle]');
    this.$cartButton = $('[data-header-site-actions-cart]', this.$el);

    // Sub-components
    this.mobileNav = new MobileNav(this.$el.find('.mobilenav'));
    this.nav = new DesktopNav(this.$el.find('.site-navigation'), section.postMessage);

    this.$megaNavTriggers = $(this.$el.find('.site-navigation')).find('[data-meganav-trigger]');
    this.$megaNavs = this.$el.find('[data-meganav]');
    this.megaNavs = [];

    this.$megaNavTriggers.each((key, megaNavTrigger) => {
      const $megaNavTrigger = $(megaNavTrigger);
      const trigger = $megaNavTrigger.data('meganav-trigger');
      const $megaNav = this.$megaNavs.filter(`[data-meganav="${trigger}"]`);
      this.megaNavs.push(new Meganav($megaNav.get(0), this.section.postMessage, trigger));
    });

    // Event handlers
    this.events = [
      // Open mobile nav button
      // Mobile safari will only allow us to focus the actual search input
      // programaticaly if we trigger it from an input field.
      this.$mobileNavToggle.on('click.header', event => {
        event.preventDefault();
        this.mobileNav.open();
      }),
      $(window).on('resize.header', debounce(() => this._repositionNav(), 16, true, true)),
      this.$cartButton.on('click.header', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.section.postMessage('header-minicart:toggle');
      }),
    ];

    this.layoutHandler = this.onBreakpointChange.bind(this);
    Layout.onBreakpointChange(this.layoutHandler);

    setTimeout(() => {
      this._repositionNav()
    }, 100);
  }

  _repositionNav() {
    this.$el.removeClass('site-navigation-flex');

    if (Layout.isBreakpoint('S')) {
      return;
    }

    this.$el.toggleClass('site-navigation-flex', !this.nav.isSingleLine());

    this.section.postMessage('header:repositionedNav');
  }

  onSectionUnload() {
    this.nav.unload();
    this.mobileNav.unload();
    this.events.forEach($el => $el.off('.header'));

    Layout.offBreakpointChange(this.layoutHandler);

    this.megaNavs.forEach(megaNav => megaNav.onSectionUnload());
  }

  onSectionMessage(name, data) {
    if (name === 'mobilenav:open') this.mobileNav.open();
    if (name === 'mobilenav:close') this.mobileNav.close();
    if (name === 'cart:update') {
      $('[data-cart-item-count]', this.$el).text(data.item_count);
      // We need to do some additional styling of the cart label if the count has 3+ digits
      if (data.item_count > 99) {
        $('[data-cart-item-count]', this.$el).addClass('cart-label-format');
      } else {
        $('[data-cart-item-count]', this.$el).removeClass('cart-label-format');
      }
    }

    if (name === 'nav:close-all') this.nav.closeAll();

    this.megaNavs.forEach(megaNav => megaNav.onSectionMessage(name, data));
  }

  onBreakpointChange() {
    if (Layout.isBreakpoint('M') || Layout.isBreakpoint('L')) {
      this.mobileNav.close();
    }
  }
}
